import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=3b6934d8"
import script from "./PersonalInfo.vue?vue&type=script&lang=ts"
export * from "./PersonalInfo.vue?vue&type=script&lang=ts"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=3b6934d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports